import NavbarSite from "../navbars/NavbarSite";
import SidebarSite from "../sidebars/SidebarSite";

const PageContainer = ({
  children,
  type,
  dateStart,
  setDateStart,
  dateEnd,
  setDateEnd,
  /** default: padding uniforme. hourly_tracking / activity: pas de py global — la page gère la ligne filtres (pt-3 pb-4 px-20) comme le suivi horaire. mission: pas de padding — la page définit bandeau intérimaire puis zone mission. */
  contentLayout = "default",
}) => {
  const mainClass =
    contentLayout === "hourly_tracking" || contentLayout === "activity"
      ? "flex min-h-0 flex-1 flex-col overflow-hidden"
      : contentLayout === "mission"
        ? "page-container-scroll flex min-h-0 flex-1 flex-col overflow-auto"
        : "page-container-scroll flex-1 overflow-auto px-[20px] py-6";

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <div className={"flex h-full min-h-0"}>
        <SidebarSite />
        <div className={"flex min-h-0 flex-1 flex-col"}>
          <NavbarSite
            type={type}
            dateStart={dateStart}
            setDateStart={setDateStart}
            dateEnd={dateEnd}
            setDateEnd={setDateEnd}
          />
          <div className={mainClass}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default PageContainer;
